// extracted by mini-css-extract-plugin
export var closeButton = "_38-0";